export enum TechnicalReportStatus {
  DRAFT = "Rascunho",
  COMPLETED = "Concluído",
  REOPENED = "Reaberto"
}

export enum TechnicalReportImageCategory {
  SERIAL_LABEL = "Etiqueta/Número de série",
  PANEL = "Painel",
  GENERAL = "Visão geral",
  ENVIRONMENT = "Ambiente",
  ELECTRICAL_PANEL = "Quadro elétrico",
  AIR_CONDITIONING = "Climatização",
  BATTERY = "Baterias",
  DEFECT = "Defeito",
  BEFORE = "Antes do serviço",
  AFTER = "Depois do serviço",
  OTHER = "Outra"
}
